import React, { useEffect, useState } from "react";
import DailySalesPanel from "./DailySalesPanel";
import WeekdayHourHeatmap from "./WeekdayHourHeatmap";
import Modal from "./ui/Modal";

const TABS = [
  { id: "days", label: "Po danima" },
  { id: "heat", label: "Dan i sat" },
];

/** "Detalji" of the revenue-per-hour card: revenue per day and the weekday x hour map. */
export default function SalesByDayModal({ open, onClose, startDate, endDate, compareStart, compareEnd, compareLabel, warehouse, darkMode }) {
  const [tab, setTab] = useState("days");
  // Every opening starts on the days tab.
  useEffect(() => {
    if (open) setTab("days");
  }, [open]);
  return (
    <Modal open={open} onClose={onClose} title="Promet po danima">
      <div className="flex flex-col gap-4">
        <div role="tablist" className="inline-flex self-start rounded-lg border border-slate-200 p-0.5 dark:border-slate-800">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              onClick={() => setTab(t.id)}
              className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
                tab === t.id
                  ? "bg-primary text-white"
                  : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        {tab === "days" ? (
          <DailySalesPanel
            startDate={startDate}
            endDate={endDate}
            compareStart={compareStart}
            compareEnd={compareEnd}
            compareLabel={compareLabel}
            warehouse={warehouse}
            darkMode={darkMode}
          />
        ) : (
          <WeekdayHourHeatmap startDate={startDate} endDate={endDate} warehouse={warehouse} />
        )}
      </div>
    </Modal>
  );
}
